<template>
  <PageEntry v-if="entry" :entry="entry" />
</template>

<script lang="js">
import PageEntry from "@/views/Page-entry.vue";
export default {
  name: 'page-entry-preview',
  components: {
    PageEntry
  },
  data() {
    return {
      entry: null,
      backOrigin: new URL(process.env.VUE_APP_BACK).origin,
    }
  },
  mounted() {
    window.addEventListener('message', this.onMessage)
    window.parent.postMessage({ type: 'entry-preview-ready' }, this.backOrigin)
  },
  beforeUnmount() {
    window.removeEventListener('message', this.onMessage)
  },
  methods: {
    onMessage(event) {
      if (event.origin !== this.backOrigin || !event.data || event.data.type !== 'entry-preview') {
        return
      }
      this.entry = event.data.entry
    }
  }
}
</script>
